import * as Types from 'constants/ActionTypes';

const heights = (state = {
    inProgress: false,
    didInvalidate: false,
    data: [],
}, action) => {
    switch (action.type) {
        case Types.FETCH_BODY_HEIGHT_UNITS:
            return Object.assign({}, state, {
                inProgress: true,
                didInvalidate: false
            })
        case Types.FETCH_BODY_HEIGHT_UNITS_SUCCESS:
            return Object.assign({}, state, {
                inProgress: false,
                didInvalidate: false,
                data: action.payload,
                lastUpdated: action.receivedAt
            })
        case Types.FETCH_BODY_HEIGHT_UNITS_FAILURE:
            return Object.assign({}, state, {
                inProgress: false,
                didInvalidate: false,
                lastUpdated: action.receivedAt
            })
        default:
            return state
    }
};

export default heights